import React, { useState, useEffect } from "react";
import { Grid, DialogContent, DialogActions } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { checkAddons, onSelectTools } from "Stores/actions";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { read } from "Helpers/LocalStorage";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import { useSetState } from "Helpers/Hooks";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import MuiCheckBoxGroup from "Components/MuiCheckboxGroup/MuiCheckboxGroup";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from "react-i18next";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";

function Addons({ openDialog, handleDialog }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { unitInfo, addonsInfo } = useSelector((state) => ({
    unitInfo: state.design.unitInfo,
    addonsInfo: state.design.addonsInfo,
  }));
  const [formValid, setFormValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    flashing: {
      type: "select",
      selectItems: [],
      value: 0,
    },
    threshold: {
      type: "select",
      selectItems: [],
      value: 0,
    },
    lifting_profile: {
      type: "select",
      selectItems: [],
      value: 0,
    },
    bottom_jamb: {
      type: "select",
      selectItems: [],
      value: 0,
    },
    toggleAddons: {
      type: "toggle",
      arrayItems: [],
      value: "",
    },
    thresholdTop: {
      type: "millimeter",
      value: 0,
      validation: {
        required: true,
        isNumeric: true,
        min: 0,
      },
    },
    thresholdBottom: {
      type: "millimeter",
      value: 0,
      validation: {
        required: true,
        isNumeric: true,
        min: 0,
      },
    },
    bottomJambBottom: {
      type: "millimeter",
      value: 0,
      validation: {
        required: true,
        isNumeric: true,
        min: 0,
      },
    },
    checkbox: {
      type: "checkbox",
      items: [
        { value: false, label: "up", key: "top" },
        { value: false, label: "down", key: "bottom" },
      ],
    },
  });

  const onEnter = async () => {
    if (unitInfo["Sys_tak_joft"] === 0) {
      await dispatch(checkAddons("threshold"));
      await dispatch(checkAddons("lifting_profile"));
      await dispatch(checkAddons("bottom_jamb"));
    }
    if (unitInfo["Sys_tak_joft"] === 1 || unitInfo["Sys_tak_joft"] === 2) {
      await dispatch(checkAddons("lifting_profile"));
    }
  };

  const onChangeToggle = (name, key, value) => {
    setControls({ [name]: { value: value } });
  };

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid(validation);
  };

  const onChangeCheckbox = (e, name, index) => {
    const items = controls[name].items;
    items[index] = { ...items[index], value: e.currentTarget.checked };
    setControls({ [name]: { items: items } });
  };

  const onFinish = () => {
    if (controls.toggleAddons.value.value === "flashing") {
      const value = {
        ...controls.flashing.value,
        type: "flashing",
      };
      dispatch(onSelectTools(value));
      handleDialog();
    }
    if (controls.toggleAddons.value.value === "threshold") {
      if (controls.checkbox.items.every((item) => item.value === false)) {
        showNotify({
          text: t("select_one_above_below"),
          customClass: "warning",
        });
      } else {
        let state = controls.checkbox.items.every((item) => item.value === true)
          ? 2
          : controls.checkbox.items[0].value === true
          ? 0
          : 1;
        const value = {
          ...controls.threshold.value,
          state,
          type: "threshold",
          bottom: controls.thresholdBottom.value,
          top: controls.thresholdTop.value,
        };
        dispatch(onSelectTools(value));
        try {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdUnit: unitInfo.Id_unit,
            IdRefrence: controls.threshold.value.value,
            Stype: 4,
          };
          DrawerService.setIdRefrenceUnit(params);
        } catch (err) {
          console.error("[catch error]", err);
        }
        handleDialog();
      }
    }
    if (controls.toggleAddons.value.value === "lifting_profile") {
      if (controls.checkbox.items.every((item) => item.value === false)) {
        showNotify({
          text: t("select_one_above_below"),
          customClass: "warning",
        });
      } else {
        let state = controls.checkbox.items.every((item) => item.value === true)
          ? 3
          : controls.checkbox.items[0].value === true
          ? 2
          : 1;
        const value = {
          ...controls.lifting_profile.value,
          state,
          type: "lifting_profile",
        };
        dispatch(onSelectTools(value));
        try {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdUnit: unitInfo.Id_unit,
            IdRefrence: controls.lifting_profile.value.value,
            Stype: 8,
          };
          DrawerService.setIdRefrenceUnit(params);
        } catch (err) {
          console.error("[catch error]", err);
        }
        handleDialog();
      }
    }
    if (controls.toggleAddons.value.value === "bottom_jamb") {
      const value = {
        ...controls.bottom_jamb.value,
        type: "bottom_jamb",
        bottom: controls.bottomJambBottom.value,
      };
      dispatch(onSelectTools(value));
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdUnit: unitInfo.Id_unit,
          IdRefrence: controls.bottom_jamb.value.value,
          Stype: 7,
        };
        DrawerService.setIdRefrenceUnit(params);
      } catch (err) {
        console.error("[catch error]", err);
      }
      handleDialog();
    }
  };

  useEffect(() => {
    (async () => {
      if (openDialog && controls.toggleAddons.value.value !== "") {
        try {
          setLoading(true);
          const keys = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
          };
          if (controls.toggleAddons.value.value === "flashing") {
            const paramsUnit = {
              ...keys,
              IdUnit: unitInfo.Id_unit,
            };
            const resUnit = await DrawerService.GetRokobUnit(paramsUnit);
            const params = {
              ...keys,
              IdStruct: unitInfo.Type_struct,
            };
            const response = await DrawerService.GetRokobCombo(params);
            const items = response.data.Value.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const value = items.find(
              (item) => item.value === resUnit.data.Value
            );
            setControls({ flashing: { value: value } });
            setControls({ flashing: { selectItems: items } });
          }
          if (controls.toggleAddons.value.value === "threshold") {
            const paramsUnit = {
              ...keys,
              IdUnit: unitInfo.Id_unit,
              Stype: 4,
            };
            const resUnit = await DrawerService.GetRefrenceUnit(paramsUnit);
            const params = {
              ...keys,
              IdProduct: unitInfo.Id_frame,
              Type: 1,
              All: true,
            };
            const response = await DrawerService.GetAstanehPakhorErtefaCombo(
              params
            );
            const items = response.data.Value.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const value = items.find(
              (item) => item.value === resUnit.data.Value.Id
            );
            setControls({ threshold: { value: value } });
            setControls({ threshold: { selectItems: items } });
          }
          if (controls.toggleAddons.value.value === "lifting_profile") {
            const paramsUnit = {
              ...keys,
              IdUnit: unitInfo.Id_unit,
              Stype: 8,
            };
            const resUnit = await DrawerService.GetRefrenceUnit(paramsUnit);
            const params = {
              ...keys,
              IdProduct: unitInfo.Id_frame,
              Type: 3,
              All: true,
            };
            const response = await DrawerService.GetAstanehPakhorErtefaCombo(
              params
            );
            const items = response.data.Value.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const value = items.find(
              (item) => item.value === resUnit.data.Value.Id
            );
            setControls({ lifting_profile: { value: value } });
            setControls({ lifting_profile: { selectItems: items } });
          }
          if (controls.toggleAddons.value.value === "bottom_jamb") {
            const paramsUnit = {
              ...keys,
              IdUnit: unitInfo.Id_unit,
              Stype: 7,
            };
            const resUnit = await DrawerService.GetRefrenceUnit(paramsUnit);
            const params = {
              ...keys,
              IdProduct: unitInfo.Id_frame,
              Type: 2,
              All: true,
            };
            const response = await DrawerService.GetAstanehPakhorErtefaCombo(
              params
            );
            const items = response.data.Value.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const value = items.find(
              (item) => item.value === resUnit.data.Value.Id
            );
            setControls({ bottom_jamb: { value: value } });
            setControls({ bottom_jamb: { selectItems: items } });
          }
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }
    })();
  }, [controls.toggleAddons.value]);

  useEffect(() => {
    if (addonsInfo) {
      let items = [{ value: "flashing", key: "rokob" }];
      const popKeys = ["threshold", "lifting_profile", "bottom_jamb"];
      const slidingKeys = ["lifting_profile"];
      if (
        unitInfo["Sys_tak_joft"] === 0 &&
        popKeys.every((elem) => Object.keys(addonsInfo).includes(elem))
      ) {
        popKeys.map((key) => {
          if (addonsInfo[key].state !== "-1") {
            items.push({ value: key, key: t(key) });
            if (key === "threshold") {
              setControls({
                thresholdBottom: { value: addonsInfo[key].bottom },
              });
              setControls({ thresholdTop: { value: addonsInfo[key].top } });
            }
            if (key === "bottom_jamb") {
              setControls({
                bottomJambBottom: { value: addonsInfo[key].bottom },
              });
            }
          }
          return null;
        });
      }

      if (
        (unitInfo["Sys_tak_joft"] === 1 || unitInfo["Sys_tak_joft"] === 2) &&
        slidingKeys.every((elem) => Object.keys(addonsInfo).includes(elem))
      ) {
        slidingKeys.map((key) => {
          if (addonsInfo[key].state !== "-1") {
            items.push({ value: key, key: t(key) });
          }
          return null;
        });
      }

      setControls({ toggleAddons: { value: items[0] } });
      setControls({ toggleAddons: { arrayItems: items } });
    }
  }, [addonsInfo]);

  return (
    <>
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <div className="dialogHeader">
          <p>
            <Translator id={"stfh_adjustment"} />
          </p>
        </div>
        <DialogContent>
          {controls.toggleAddons.arrayItems.length > 1 && (
            <MuiRadioGroup
              name={"toggleAddons"}
              value={controls.toggleAddons.value}
              items={controls.toggleAddons.arrayItems}
              onChange={onChangeToggle}
              translate={true}
              className="horizontalRadio"
            />
          )}

          {!loading ? (
            <Grid container spacing={1} className="mt-3">
              {
                //!------------------------------------------------ flashing
                controls.toggleAddons.value.value === "flashing" && (
                  <Grid item sm={6} xs={12}>
                    <MuiAutoComplete
                      loading={loading}
                      options={controls.flashing.selectItems}
                      label={<Translator id={"flashing"} />}
                      value={controls.flashing.value}
                      id={"flashing"}
                      onChange={autoCompleteHandler}
                    />
                  </Grid>
                )
              }

              {
                //!------------------------------------------------ threshold
                controls.toggleAddons.value.value === "threshold" && (
                  <>
                    <Grid item xs={12}>
                      <MuiAutoComplete
                        loading={loading}
                        options={controls.threshold.selectItems}
                        label={<Translator id={"threshold"} />}
                        value={controls.threshold.value}
                        id={"threshold"}
                        onChange={autoCompleteHandler}
                      />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      <Input
                        disabled={addonsInfo.threshold.state === 0}
                        setValue={setValue.bind(this)}
                        name="thresholdBottom"
                        value={controls.thresholdBottom.value}
                        validation={controls.thresholdBottom.validation}
                        label={<Translator id={"thresholdBottom"} />}
                        type="text"
                        icon={<Translator id={"millimeter"} />}
                      />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      <Input
                        disabled={addonsInfo.threshold.state === 1}
                        setValue={setValue.bind(this)}
                        name="thresholdTop"
                        value={controls.thresholdTop.value}
                        validation={controls.thresholdTop.validation}
                        label={<Translator id={"thresholdTop"} />}
                        type="text"
                        icon={<Translator id={"millimeter"} />}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MuiCheckBoxGroup
                        label={<Translator id={"threshold_location"} />}
                        name="checkbox"
                        value={controls.checkbox.value}
                        items={controls.checkbox.items}
                        onChange={onChangeCheckbox}
                        className="horizontalCheckbox"
                      />
                    </Grid>
                  </>
                )
              }

              {
                //!------------------------------------------------ lifting_profile
                controls.toggleAddons.value.value === "lifting_profile" && (
                  <>
                    <Grid item xs={12}>
                      <MuiAutoComplete
                        loading={loading}
                        options={controls.lifting_profile.selectItems}
                        label={<Translator id={"lifting_profile"} />}
                        value={controls.lifting_profile.value}
                        id={"lifting_profile"}
                        onChange={autoCompleteHandler}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MuiCheckBoxGroup
                        label={<Translator id={"elevation_direction"} />}
                        name="checkbox"
                        value={controls.checkbox.value}
                        items={controls.checkbox.items}
                        onChange={onChangeCheckbox}
                        className="horizontalCheckbox"
                      />
                    </Grid>
                  </>
                )
              }

              {
                //!------------------------------------------------ bottom_jamb
                controls.toggleAddons.value.value === "bottom_jamb" && (
                  <>
                    <Grid item sm={6} xs={12}>
                      <MuiAutoComplete
                        loading={loading}
                        options={controls.bottom_jamb.selectItems}
                        label={<Translator id={"bottom_jamb"} />}
                        value={controls.bottom_jamb.value}
                        id={"bottom_jamb"}
                        onChange={autoCompleteHandler}
                      />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      <Input
                        setValue={setValue.bind(this)}
                        name="bottomJambBottom"
                        value={controls.bottomJambBottom.value}
                        validation={controls.bottomJambBottom.validation}
                        label={<Translator id={"bottom_footrest_length"} />}
                        type="text"
                        icon={<Translator id={"millimeter"} />}
                      />
                    </Grid>
                  </>
                )
              }
            </Grid>
          ) : (
            <MuiSkeleton xs={6} number={4} />
          )}
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            onClick={onFinish}
            title={<Translator id={"button_save"} />}
          />
          <MuiButton
            onClick={handleDialog}
            title={<Translator id={"enseraf"} />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Addons;
